import { Box, ScrollArea, Stack, Title } from '@mantine/core'
import React from 'react'
import { HostedAssistantManager } from '../components/HostedAssistantManager'

/** Standalone "Assistants" configuration page (left-nav, below Chat). Create and edit cloud assistants. */
export const AssistantsConfigPage: React.FC = () => {
  return (
    <Box style={{ height: '100%', minHeight: 0, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
      <ScrollArea style={{ flex: 1, minHeight: 0 }} type="auto" offsetScrollbars>
        <Stack gap="md" p="lg" maw={760} mx="auto" w="100%">
          <Title order={3}>Assistants</Title>
          <HostedAssistantManager layout="settings" />
        </Stack>
      </ScrollArea>
    </Box>
  )
}
